module.exports = __webpack_public_path__ + "static/10-4a225442e98faa8a885309f68fddb64e.png";